// useThaiInput.js
import { useEffect } from 'react';

const useThaiInput = (inputRef) => {
  const handleKeyDown = (e) => {
    const thaiPattern = /[ก-๙ ะ-๛]/; // Thai language character range
    const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Backspace', 'Delete'];

    if (!thaiPattern.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('keydown', handleKeyDown);
      return () => {
        inputRef.current.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [inputRef]);

  return handleKeyDown;
};

export default useThaiInput;
